import { TextLink, textLinkVariants } from '@/shared/ui'
import type { CatalogComponentEntry } from './component-registry.types'

const formatTextLinkSummary = (variantId: keyof typeof textLinkVariants) => {
  const variant = textLinkVariants[variantId]
  return `Tokens: size=${variant.size}, underline=${variant.underline}, align=${variant.align}`
}

export const textLinkEntries: CatalogComponentEntry[] = [
  {
    name: 'TextLink / primary',
    path: 'shared/ui/text-link',
    layer: 'shared',
    description: `Figma: 78:838. ${formatTextLinkSummary('primary')}`,
    component: TextLink,
    render: () => (
      <div className="rounded-lg px-4 py-3">
        <TextLink href="#" className="w-full" onClick={(event) => event.preventDefault()}>
          Text link
        </TextLink>
      </div>
    ),
  },
]
